<template>
  <div class="orderList orderNew">
    <div class="order-content" v-if="moduleType !== 'TRIP' && moduleType !== 'RETAIL'">
      <div class="info-box">
        <div class="title">订单中心</div>
        <el-divider></el-divider>
        <!-- 状态切换区 -->
        <div class="nav-box">
          <ul>
            <li v-for="(item, index) in navList" :key="index" :class="[tabPage === index ? 'active':'']" @click="handleTabPage(index)">{{ item.label }}</li>
          </ul>
        </div>
        <!-- 列表 -->
        <ul class="mt10" v-if="orderList.length > 0">
          <li class="flex-between order-item" v-for="(item, index) in orderList" :key="index">
            <div class="flex-align-center">
              <img v-if="item.mainPic" class="order-img" :src="item.mainPic" alt="">
              <img v-else class="order-img" src="../../assets/images/default_img.jpg" alt="">
              <div class="flex-column-between order-item-info">
                <h4 class="order-title" @click="handleToDetail(item)">{{item.merchIndustryName}}-{{item.goodsName}}</h4>
                <div>
                  <p class="mb10">
                    <span class="lable">下单时间:</span>
                    <span class="lable-value">{{item.crtTime}}</span>
                  </p>
                  <p class="mb10">
                    <span class="lable">购买数量:</span>
                    <span class="lable-value" v-if="moduleType==='HOTEL'">共{{ item.quantity }}间{{ item.stayDays || '--'}}晚</span>
                    <span class="lable-value" v-else>{{item.quantity}}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="order-pay">实付款: ¥{{item.paymentTotal}}
              <span v-if="item.payTypeName">({{item.payTypeName}})</span>
            </div>
            <p class="order-status">{{item.statusName}}</p>
            <div class="flex-column-center">
              <a v-if="item.status === 0" class="order-btn" @click="handleToPay(item)">支付</a>
              <a class="order-btn redbg" v-if="moduleType === 'FOOD' && item.status === 28 && !item.isReviewed" @click="handleToEvaluate(item)">去评价</a>
              <a class="order-btn" v-if="moduleType === 'FOOD' && item.status === 28 && item.isReviewed" @click="handleLookEvalute(item)">查看评价</a>
              <a class="order-btn redbg" v-if="moduleType === 'PACKAGES' && (item.status === 6 || item.status === 10 || item.status === 20)" @click="handleToRefund(item)">退款</a>
              <a class="order-btn redbg" @click="handleToDetail(item)">订单详情</a>
            </div>
          </li>
        </ul>
        <div v-else class="no-data">暂无数据</div>
        <!-- 分页 -->
        <div class="pagination-self">
            <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="totalCount"
            >
            </el-pagination>
        </div>
      </div>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
    <!-- 支付弹框 -->
    <payDialog ref="payDialog" :from="from" />
    <!-- 退款弹框 -->
    <refundDialog ref="refundDialog" @loadDetail="loadList" />
    <!-- 查看评价 -->
    <lookEvaluateDialog ref="lookEvaluateDialog" />
  </div>
</template>

<script>
import PayDialog from '@/components/payDialog'
import RefundDialog from '@/components/refundDialog'
import LookEvaluateDialog from '@/components/lookEvaluateDialog'
import { config } from '@/constant/config'
import { loadDetail, loadList } from '@/api/myOrder'
export default {
  data () {
    return {
      tabPage: 0,
      navList: [
        { label: '全部订单', code: null },
        { label: '待付款', code: 'UNPAY' },
        { label: '待使用', code: 'UNUSE' },
        { label: '待评价', code: 'UNCOMMET' },
        { label: '退款', code: 'REFUND' }
      ],
      totalCount: 0,
      moduleType: 'TRIP',
      page: 1,
      limit: 10,
      orderList: [],
      from: null
    }
  },
  components: {
    'payDialog': PayDialog,
    'refundDialog': RefundDialog,
    'lookEvaluateDialog': LookEvaluateDialog
  },
  created () {
    this.moduleType = this.$route.query.moduleType || 'HOTEL'
    if (this.$route.path === '/tripOrderList') {
      this.moduleType = 'TRIP'
    } else if (this.$route.path === '/retailOrderList') {
      this.moduleType = 'RETAIL'
    }
    if (this.moduleType === 'TRIP') {
      this.$router.replace({ path: '/tripOrderList', query: { t: Date.now() } })
      return
    } else if (this.moduleType === 'RETAIL') {
      this.from = 'cart'
      this.$router.replace({ path: '/retailOrderList',
        query: {
          t: Date.now(),
          moduleType: 'RETAIL'
        } })
      return
    }
    this.loadList()
  },
  methods: {
    handleLookEvalute (item) {
      this.$refs.lookEvaluateDialog.handleOpenDialog(item)
    },
    handleToPay (item) {
      if (this.flag) return
      this.flag = true
      let orderNo = item.orderNo
      if (this.moduleType === 'RETAIL') {
        orderNo = '[' + item.uniteOrderNo + ']'
      }
      this.$refs.payDialog.toPay(orderNo, item.orderCat)
    },
    handleToRefund (item) {
      if (item.orderCat === 'PACKAGES') {
        this.$refs.refundDialog.loadPackagesRefundData(item)
      } else {
        const loading = this.$loading({
          lock: true,
          text: '请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        loadDetail(item.orderNo, item.orderCat).then(res => {
          loading.close()
          if (res.code === 0 && res.data) {
            this.orderInfo = res.data
            this.$refs.refundDialog.handleShowDialog(res.data)
          }
        })
      }
    },
    handleTabPage (index) {
      this.tabPage = index
      this.page = 1
      this.loadList()
    },
    handleToDetail (item) {
      this.$router.push({ path: 'orderDetailNew', query: { orderNo: item.orderNo, mainPic: item.mainPic, moduleType: this.moduleType } })
    },
    handleToEvaluate (item) {
      const info = {
        mainPic: item.mainPic,
        paymentTotal: item.paymentTotal,
        orderNo: item.orderNo,
        merchIndustryId: item.merchIndustryId,
        merchIndustryName: item.merchIndustryName,
        goodsId: item.goodsId,
        goodsName: item.goodsName
      }
      this.$router.push({ path: 'orderEvaluate', query: { info: JSON.stringify(info), moduleType: this.moduleType } })
    },
    loadList () {
      const data = {
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        page: this.page,
        limit: this.limit,
        status: this.navList[this.tabPage].code,
        orderCat: this.moduleType
      }
      loadList(data).then(res => {
        if (res.code === 0) {
          this.orderList = res.data.list.map((val) => {
            val.paymentTotal = Number(val.paymentTotal).toFixed(2)
            val.mainPic = null
            if (val.goodsPicture) {
              const pictures = JSON.parse(val.goodsPicture)
              val.mainPic = pictures.find(pic => pic.index === 1) && pictures.find(pic => pic.index === 1).url
            }
            return val
          })
          this.totalCount = res.data.totalCount
        }
      })
    },
    // 翻页
    handleCurrentChange (val) {
      this.page = val
      this.loadList()
    }
  }
}
</script>

<style lang="scss" scoped>
.orderList{
  .order-item{
    overflow-x: auto;
    padding: 30px 0;
    border-bottom: 1px solid #8fa8bc81;
    .order-img{
      width: 207px;
      height: 130px;
      margin-right: 24px;
    }
    .order-item-info{
      width: 300px;
      height: 130px;
      .order-title{
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 36px;
        color: #242B34;
        cursor: pointer;
        margin: 0;
        &:hover{
          color: #9B232A
        }
      }
      .lable{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9FA1B0;
      }
      .lable-value{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #424855;
      }
    }
    .order-pay{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: #424855;
      white-space: nowrap;
    }
    .order-status{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: #424855;
      white-space: nowrap;
      margin: 0 10px;
    }
    .order-btn {
      width: 120px;
      height: 36px;
      line-height: 36px;
      border: 1px solid #9B232A;
      border-radius: 4px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #9B232A;
      text-align: center;
      cursor: pointer;
      &:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }
    .redbg {
      background: #9B232A;
      color: #FFFFFF;
    }
    .w120 {
      width: 120px;
    }
  }
}
</style>
